import React from 'react';
import {
  useFormMethods,
  useFormWatch,
} from '../../../../../../../../helpers/formManager';
import SelectIntervalTime from '../../../../../../controllers/base/SelectIntervalTime';
import { useTimeIntervals } from '../../../../../../services/timeIntervals';
import { useAllowClearClassicTime } from '../../../../../../services/allowClearClassicTime';

const TimesSelection = ({ startName, endName, durationName, immutable }) => {
  const duration = useFormWatch({ name: durationName, exact: true });

  const allowClearTime = useAllowClearClassicTime();

  const timeIntervals = useTimeIntervals();

  const { getValues } = useFormMethods();

  const props = {
    startName,
    endName,
    duration,
    timeIntervals,
    immutable,
    getValues,
    allowClear: allowClearTime,
  };

  return (
    <>
      <SelectStartTime {...props} />
      <SelectEndTime {...props} />
    </>
  );
};

export default TimesSelection;

function SelectStartTime({
  startName,
  endName,
  duration,
  timeIntervals,
  getValues,
  immutable,
  allowClear,
}) {
  const to = useFormWatch({ name: endName, exact: true });

  const options = timeIntervals.getTimesByDuration(duration, 'from');

  const isAvailable = timeIntervals.createIsFromAvailableFn({
    duration,
    to,
    current: immutable ? getValues(startName) : undefined,
  });

  const { preparedOptions, hasAvailable } = prepareOptions(
    options,
    isAvailable
  );

  return (
    <SelectIntervalTime
      name={startName}
      label="Начало первого интервала"
      requiredErrMsg="Укажите начало первого интервала"
      options={preparedOptions}
      hasDuration={Boolean(duration)}
      hasAvailableOptions={hasAvailable}
      allowClear={allowClear}
    />
  );
}

function SelectEndTime({
  startName,
  endName,
  duration,
  timeIntervals,
  getValues,
  immutable,
  allowClear,
}) {
  const from = useFormWatch({ name: startName, exact: true });

  const options = timeIntervals.getTimesByDuration(duration, 'to');

  const isAvailable = timeIntervals.createIsToAvailableFn({
    duration,
    from,
    current: immutable ? getValues(endName) : undefined,
  });

  const { preparedOptions, hasAvailable } = prepareOptions(
    options,
    isAvailable
  );

  return (
    <SelectIntervalTime
      name={endName}
      label="Окончание последнего интервала"
      requiredErrMsg="Укажите окончание последнего интервала"
      options={preparedOptions}
      hasDuration={Boolean(duration)}
      hasAvailableOptions={hasAvailable}
      allowClear={allowClear}
    />
  );
}

function prepareOptions(options, isAvailable) {
  let hasAvailable = false;

  const preparedOptions = options?.map((option) => {
    const disabled = !isAvailable(option) ?? false;

    if (!disabled) {
      hasAvailable = true;
    }

    return { option, disabled };
  });

  return { preparedOptions, hasAvailable };
}
